import React from "react";
import {useEffect, useState} from "react";
import {carrierService} from "../../../services";
import {Button, Col, Modal, notification, Row, Spin} from "antd";
import SelectField from '../../select-field';
import ModalCreateContractOrder from "../create-contract-order";
import ModalGuarantorBeforeContract from "../guarantor-before-contract";
import BelarusEditGuarantor from "../belarus-edit-guarantor";
import { consignorService } from "../../../services/consignor.services";
import { companyService } from "../../../services/company.services";
import i18n from "../../../i18n";
import { crossDockService } from "../../../services/cross-dock.services";

export default function ModalSelectCarrierLegalEntity({
                                                        isShow,
                                                        setIsShow,
                                                        delivery,
                                                        setNeedUpdateDeliveryList,
                                                        setStopListUpdate,
                                                        initLegalEntity,
                                                        allowContractTypes=['carriage', 'container']
                                                      }) {
  const [loadingContentModal, setLoadingContentModal] = useState(false);
  const [listCompanies, setListCompanies] = useState([]);
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showOrderToShipperCompanyModal, setShowOrderToShipperCompanyModal] = useState(false);
  const [legalEntityId, setLegalEntityId] = useState(null);
  const [showGuarantorModal, setShowGuarantorModal] = useState(false);
  const [showBelarusGuarantorModal, setShowBelarusGuarantorModal] = useState(false);
  const [skipGuarantorPrecheck, setSkipGuarantorPrecheck] = useState(false);
  const currentShipperCompanyId = delivery.CustomerCompanyId;

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };


  useEffect(() => {
    if (isShow) {
      if(allowContractTypes.includes('cross_dock')) {
        crossDockService.getLegalEntities(50)
          .then((companies) => {
            setListCompanies(companies);
          })
          .catch((error) => {
            setLoadingContentModal(false);
            notification.error({
              message: i18n.t('components.notification.titles.getCarrierCompanies'),
              description: error,
            });
          });
      } else {
        carrierService.getCompanies(50)
          .then((companies) => {
            setListCompanies(companies.LegalEntities);
          })
          .catch((error) => {
            setLoadingContentModal(false);
            notification.error({
              message: i18n.t('components.notification.titles.getCarrierCompanies'),
              description: error,
            });
          });
      }
    }
  }, [isShow]);

  useEffect(() => {

    if (isShow && !loadingContentModal) {
      setLoadingContentModal(true);
      setStopListUpdate(true);
    }
  }, [isShow]);


  useEffect(() => {
    if (listCompanies && listCompanies.length) {
      setLoadingContentModal(false);
    }
  }, [listCompanies]);


  const getFieldErrors = (nameField) => {

    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  if (!loadingContentModal && listCompanies) {
    if (listCompanies.length && legalEntityId === null) {
      setLegalEntityId(initLegalEntity);
    }
  }

  const checkGuarantorNeed = async () => {
    try {
      if(allowContractTypes.includes('cross_dock')) {
        setShowGuarantorModal(false);
        setShowBelarusGuarantorModal(false);
        setShowOrderToShipperCompanyModal(true);
        return;
      }
      const info = await consignorService.geShipperCompanyInfo(currentShipperCompanyId);
      let consignorId = null;
      if (info) {
        if (info.Consignor && info.Consignor.Id) consignorId = info.Consignor.Id;
        else if (typeof info.consignorId !== 'undefined') consignorId = info.consignorId;
        else if (typeof info.ConsignorId !== 'undefined') consignorId = info.ConsignorId;
        else if (info.consignor && info.consignor.Id) consignorId = info.consignor.Id;
      }
      if (!consignorId) {
        setShowOrderToShipperCompanyModal(true);
        return;
      }
      const premium = await consignorService.getPremiumAccessList(consignorId);
      const payload = (premium && premium.data) ? premium.data : premium;
      let needGuarantor = false;
      if (payload) {
        if (payload.list && typeof payload.list['guarantor_required'] !== 'undefined') {
          needGuarantor = payload.list['guarantor_required'] === true;
        } else if (typeof payload['guarantor_required'] !== 'undefined') {
          needGuarantor = payload['guarantor_required'] === true;
        }
      }
      const legalEntity = await companyService.getLegalEntityData(legalEntityId);
      const isProprietor = !!(
        (legalEntity && legalEntity.IsProprietorType) ||
        (legalEntity && legalEntity.isProprietor) ||
        (legalEntity && legalEntity.OrgForm && legalEntity.OrgForm.IsProprietorType) ||
        (legalEntity && legalEntity.OrgFormId === 16) || //ИП Белорусии    
        (legalEntity && legalEntity.OrgFormId === 27)  //ИП Казахстана
      );
        const guarantorWrited = !!(legalEntity && 
            legalEntity && legalEntity.GuarantorFirstName &&
            legalEntity && legalEntity.GuarantorPassportNumber);
        
      if (needGuarantor && !isProprietor && !guarantorWrited) {
        if (legalEntity && legalEntity.CountryId === 1) {
          setShowBelarusGuarantorModal(false);
          setShowGuarantorModal(true);
          return;
        }
        if (legalEntity && (legalEntity.CountryId === 3 || legalEntity.CountryId === 6)) {
          setShowGuarantorModal(false);
          setShowBelarusGuarantorModal(true);
          return;
        }
      }
      setShowGuarantorModal(false);
      setShowBelarusGuarantorModal(false);
      setShowOrderToShipperCompanyModal(true);
    } catch (e) {
      setShowOrderToShipperCompanyModal(true);
    }
  };

  let content;

  if (errorMsg) {
    content = (<div className="content-error-block">{errorMsg}</div>);
  } else {
    content = (
      <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{i18n.t('modals.modalSelectCarrierLegalEntity.text')} <span>{delivery.CustomerCompany}</span></h2>
        </Row>
        <Row gutter={[24, 26]}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <SelectField
              title={i18n.t('modals.modalSelectCarrierLegalEntity.fields.companyId.title')}
              name="companyId"
              selectedValue={legalEntityId}
              values={listCompanies}
              onChange={(value) => {
                setLegalEntityId(value);
              }}
              getErrors={getFieldErrors}
              notFoundText={i18n.t('modals.modalSelectCarrierLegalEntity.fields.companyId.notFoundText')}
              style={{width: "100%"}}
            />
          </Col>
        </Row>
      </Spin>
    );
  }

  return (
    <>
      <Modal
        title={i18n.t('modals.modalSelectCarrierLegalEntity.title')}
        okText={i18n.t('modals.modalSelectCarrierLegalEntity.buttons.createOrder')}
        cancelText={i18n.t('main.buttons.close')}
        className="modal-window"
        align={null}
        visible={isShow}
        onCancel={() => {
          setIsShow(false);
          setNeedUpdateDeliveryList(true);
          setStopListUpdate(false);
        }}
        footer={[
          (errorMsg === null)
            ? (
              <Button
                htmlType="button"
                disabled={loadingContentModal}
                style={bigButtonStyle}
                key="submit"
                type="primary"
                onClick={async () => { await checkGuarantorNeed(); }}
              >
                {i18n.t('main.buttons.send')}
              </Button>
            )
            : null,
        ]}
      >
        {content}
      </Modal>
      <ModalGuarantorBeforeContract
        visible={showGuarantorModal}
        onClose={() => setShowGuarantorModal(false)}
        legalEntityId={legalEntityId}
        onSaved={() => {
          setShowGuarantorModal(false);
          setSkipGuarantorPrecheck(true);
          setTimeout(() => setShowOrderToShipperCompanyModal(true), 0);
        }}
      />
      <BelarusEditGuarantor
        isShow={showBelarusGuarantorModal}
        setIsShow={setShowBelarusGuarantorModal}
        legalEntityId={legalEntityId}
        onSaved={() => {
          setShowBelarusGuarantorModal(false);
          setSkipGuarantorPrecheck(true);
          setTimeout(() => setShowOrderToShipperCompanyModal(true), 0);
        }}
      />
      <ModalCreateContractOrder shipperCompanyID={currentShipperCompanyId} legalEntityID={legalEntityId} skipGuarantorPrecheck={skipGuarantorPrecheck}
                                isShow={showOrderToShipperCompanyModal} setIsShow={setShowOrderToShipperCompanyModal} allowContractTypes={allowContractTypes}/>
    </>
  );
}
